module.exports = __webpack_public_path__ + "img/ManagedService-Service.7180e1b.svg";